import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { Language } from "../../utils";
import makeClasses from "./styles";
import { useSelector } from "react-redux";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import clsx from "clsx";
import PlanCard from "./PlanCard";

const PaymentPlansModal = ({ open, branch, onClose, hasRUT = false }) => {
  const classes = makeClasses();

  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  const cards = [
    {
      name: i18n.get("PaymentPlans.ClassicPlan.name"),
      debitPaymentDate: i18n.get("PaymentPlans.ClassicPlan.debitPaymentDate"),
      creditPaymentDate: i18n.get("PaymentPlans.ClassicPlan.creditPaymentDate"),
      credit2To6PaymentDate: i18n.get("PaymentPlans.ClassicPlan.credit2To6PaymentDate"),
    },
    {
      name: i18n.get("PaymentPlans.FourteenPlan.name"),
      debitPaymentDate: i18n.get("PaymentPlans.FourteenPlan.debitPaymentDate"),
      creditPaymentDate: i18n.get("PaymentPlans.FourteenPlan.creditPaymentDate"),
      credit2To6PaymentDate: i18n.get("PaymentPlans.FourteenPlan.credit2To6PaymentDate"),
    },
    {
      name: i18n.get("PaymentPlans.YaPlan.name"),
      debitPaymentDate: i18n.get("PaymentPlans.YaPlan.debitPaymentDate"),
      creditPaymentDate: i18n.get("PaymentPlans.YaPlan.creditPaymentDate"),
      credit2To6PaymentDate: i18n.get("PaymentPlans.YaPlan.credit2To6PaymentDate"),
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitleWrapper}>
        <div
          className={clsx(
            classes.dialogTitle,
            classes.dialogTitleWithCloseButton,
          )}>
          {i18n.get("PaymentPlans.ModalTitle")}
        </div>
        <div className={classes.dialogTitleClose} onClick={onClose}>
          <CancelOutlinedIcon
            className={classes.dialogTitleCloseIcon}
            color="inherit"
          />
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContentWrapper}>
        <div className={classes.cardsContainer}>
          {cards.map((card) => (
            <PlanCard key={card.name} {...card} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentPlansModal;
